/* =====================================================================
   PENDELLE — ampoules du panier (module chargé sur toutes les pages : le panier latéral existe partout)
   Le panier contient UNE ligne d'ampoules, en quantité 1 : la variante « teinte / lot de N ampoules » (N = besoin des
   luminaires, calculé côté serveur par snippets/pd-bulb-needs.liquid et lu ici dans <script data-bulb-state> du panier
   latéral, rafraîchi à chaque changement du panier).
   Règles :
     1. Synchronisation : à chaque changement du panier (et à l'ouverture d'une page), état.fix est appliqué :
        ligne en trop ou sans besoin retirée, quantité ramenée à 1, mauvais lot remplacé par le lot de N (même teinte).
     2. Ajout : [data-bulb-add] ajoute le lot choisi en UNE requête /cart/add.js (quantité 1), puis relit le panier.
     3. Garde-fou : le paiement et le paiement rapide sont masqués tant que le panier n'est pas en règle
        (attribut data-bulb-locked du formulaire du panier latéral).
   Sécurité : une seule synchronisation à la fois (verrou), au plus 4 passes de suite, aucune erreur en console.
   ===================================================================== */
(function () {
  'use strict';
  var PD = window.PD = window.PD || {};
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var R = PD.routes || {};
  var CHANGE = R.cartChange || ROOT + 'cart/change.js';
  var ADD = R.cartAdd || ROOT + 'cart/add.js';
  var running = false, again = false, passes = 0, adding = false;
  var tone = ''; /* teinte choisie, conservée quand le panier est redessiné */

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function post(url, body) {
    return fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'erreur'); return j; }); });
  }
  function readState() {
    var el = $('#ovCart [data-bulb-state]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  function refresh() { return PD.refreshCart ? PD.refreshCart(false) : Promise.resolve(); }

  /* ---- verrou du paiement (le bloc « express » du panier latéral n'est jamais redessiné) ---- */
  function applyLock(st) {
    var f = $('#ovCart .cart-f');
    if (f && st) { if (st.blocked) f.setAttribute('data-bulb-locked', ''); else f.removeAttribute('data-bulb-locked'); }
  }

  /* ---- teinte : mémoire du choix + prix ---- */
  function restoreTone(root) {
    if (!tone) return;
    $$('[data-bulb-offer]', root).forEach(function (box) {
      $$('input[type=radio]', box).forEach(function (r) { if (r.getAttribute('data-tone') === tone) r.checked = true; });
      updateTotal(box);
    });
  }
  function updateTotal(box) {
    var out = $('[data-bulb-total]', box), r = $('input[type=radio]:checked', box);
    if (!out || !r || box.getAttribute('data-free') === 'true') return;
    if (PD.money) out.textContent = PD.money(+r.getAttribute('data-price'));
  }

  /* ---- synchronisation ---- */
  function applyFix(f) {
    /* l'ancienne ligne est retirée AVANT l'ajout du nouveau lot : l'ajout change la remise, donc la clé de l'ancienne ligne
       (la clé d'une ligne dépend de ses remises) et sa suppression par clé échouerait ensuite */
    return post(CHANGE, { id: f.key, quantity: f.qty }).catch(function () {}).then(function () {
      return f.add ? post(ADD, { items: [{ id: +f.add, quantity: 1 }] }).catch(function () {}) : null;
    });
  }
  function sync() {
    var st = readState();
    applyLock(st);
    if (!st || !st.fix || !st.fix.length) { passes = 0; return; }
    if (running) { again = true; return; }
    if (passes >= 4) return;
    running = true; passes++;
    var chain = Promise.resolve();
    st.fix.forEach(function (f) { chain = chain.then(function () { return applyFix(f); }); });
    chain.then(refresh).catch(function () {}).then(function () {
      running = false;
      if (again) { again = false; sync(); }
    });
  }

  /* ---- ajout ---- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-bulb-add]');
    if (!btn) return;
    e.preventDefault();
    if (adding || btn.disabled) return;
    var box = btn.closest('[data-bulb-offer]'); if (!box) return;
    var r = $('input[type=radio]:checked', box), msg = $('[data-bulb-msg]', box);
    if (!r) return;
    adding = true; btn.disabled = true; btn.classList.add('is-loading');
    if (msg) msg.textContent = '';
    post(ADD, { items: [{ id: +r.value, quantity: 1 }] })
      .then(refresh)
      .catch(function () { if (msg) msg.textContent = 'Les ampoules n’ont pas pu être ajoutées, merci de réessayer.'; })
      .then(function () { adding = false; btn.disabled = false; btn.classList.remove('is-loading'); });
  });
  document.addEventListener('change', function (e) {
    var r = e.target;
    if (!r.matches || !r.matches('[data-bulb-offer] input[type=radio]')) return;
    tone = r.getAttribute('data-tone') || '';
    updateTotal(r.closest('[data-bulb-offer]'));
  });

  /* ---- démarrage ---- */
  document.addEventListener('pd:cart', function () { restoreTone(document); sync(); });
  function start() {
    sync();
    var pg = $('[data-pd-cartpage]');
    if (pg && !pg.__bulbObs && window.MutationObserver) {
      pg.__bulbObs = new MutationObserver(function () { restoreTone(pg); });
      pg.__bulbObs.observe(pg, { childList: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  window.addEventListener('pageshow', function (e) { if (e.persisted) sync(); });
  document.addEventListener('shopify:section:load', start);
  PD.bulbSync = sync;
})();
